import React from 'react';

import { SliderWrapper } from './RoSliderWrapper.styles';

const RoSliderWrapper = props => <SliderWrapper {...props}>{props.children}</SliderWrapper>;

export default RoSliderWrapper;
